module.exports = __webpack_public_path__ + "static/media/leaf-maple.9e991552.svg";